import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes/types";

const baseRoute = `/notifications`;

export const notificationsRoutesObj = {
  base: baseRoute,
} as const;

export type INotificationsRouteParams = IExtractRouteParamMap<
  typeof notificationsRoutesObj
>;

export const notificationsPath = createPaths<
  typeof notificationsRoutesObj,
  INotificationsRouteParams
>(notificationsRoutesObj);
